import React, { Component } from 'react';
import _memoize from 'lodash.memoize';
import Dropdown from '../../../../Dropdown';
import AdvancedFilters from '../../../../AdvancedFilters';
import Text from '../../../../Text';

import { getFilterValue } from '../utils/filtersValues';
import ActionPopup from '../../../../ActionPopup';
import Icon from '../../../../Icon';
import LinkButton from '../../../../Link';
import Button from '../../../../Button';
import '../styles/_filters-mobile.scss';























class FiltersMobile extends Component {
  constructor() {
    super();

    this.state = {
      filterValues: {}
    };
  }

  onSelectFilter = _memoize((filterName) => (selectedValue) => {
    this.setState(({ filterValues }) => (
    { filterValues: { ...filterValues, ...getFilterValue(filterName, selectedValue) } }),
    () => {
      const { setSelectedFilters } = this.props;
      const { filterValues } = this.state;

      setSelectedFilters(filterValues);
    });
  });

  onResetFilters = () => {
    const { resetFilters } = this.props;

    this.setState({ filterValues: {} });

    resetFilters();
  };

  render() {
    const {
      advanceFilterName,
      filters,
      selectedFilters,
      advancedFilters,
      onAdvancedFiltersChange,
      history,
      isCollapsible,
      containerSize,
      numResults,
      stats,
      shouldReturnOptionAllSelections,
      isAdvancedFilterPersistent,
      initialUpdate
    } = this.props;
    const { filterValues } = this.state;

    return (
      <div>
        <ActionPopup
          className="filters-mobile"
          options={[]}
          popupBtn={
          <Button
            prefix={
            <Icon
              name="preferences" />} />}>





          <div className="filters-mobile__header">
            <Text heading4 noMargin>Filter</Text>
            <LinkButton
              className="advanced-filters__header__reset"
              onClick={this.onResetFilters}>

              Reset Filters
            </LinkButton>
          </div>
          {Object.keys(filters).map((key) => Array.isArray(filters[key]) ?

          <Dropdown
            key={key}
            id="all-filter-dropdown"
            options={filters[key]}
            defaultValue={selectedFilters[key] || filterValues[key] || filters[key][0]}
            onChange={this.onSelectFilter(key)}
            type="BUTTON"
            renderMenuLocally /> :



          <Dropdown
            key={key}
            id="all-filter-dropdown"
            options={filters[key].options || []}
            onChange={this.onSelectFilter(key)}
            type="BUTTON"
            renderMenuLocally
            {...filters[key]} />


          )}
          <AdvancedFilters
            advanceFilterName={advanceFilterName}
            history={history}
            location={window.location}
            filters={advancedFilters}
            onUpdateFilters={onAdvancedFiltersChange}
            isCollapsible={isCollapsible}
            containerSize={containerSize}
            numResults={numResults || 0}
            stats={stats}
            shouldReturnOptionAllSelections={shouldReturnOptionAllSelections}
            isPersistent={isAdvancedFilterPersistent}
            initialUpdate={initialUpdate} />

        </ActionPopup>
      </div>);

  }
}

export default FiltersMobile;